module.exports = __webpack_public_path__ + "img/9aa6354.jpg";